import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
} from '@angular/core';
import Vapi from '@vapi-ai/web';
import { CommonService } from 'src/app/shared/service/common.service';
import { environment } from 'src/environments/environment';
import { VoiceAssistantService } from '../../service/voiceAssistantService.service';
import { BehaviorSubject } from 'rxjs';
import { HttpStatusCode } from '@angular/common/http';
import {
  LoggedInUserKeys,
  LoggedInUserService,
} from '../../service/logged-in-user.service';
import { AppUsersDto } from '../../model/app-users-dto';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-interview-call-layout',
  templateUrl: './interview-call-layout.component.html',
  styleUrls: ['./interview-call-layout.component.scss'],
  standalone: false,
})
export class InterviewCallLayoutComponent implements OnInit, OnDestroy {
  @Input() transcripts: any[] = [];
  @Input() agentSpeakingState: boolean = false;
  @Input() userName: string = 'User';
  @Output() messageSend = new EventEmitter<string>();
  @Output() micMute = new EventEmitter<boolean>();
  @Output() changeDefaultView = new EventEmitter<boolean>();
  vapi: Vapi | null = null;
  callStartingLoadingState$ = new BehaviorSubject<boolean>(false);
  showVoiceCallSection$ = new BehaviorSubject<boolean>(false);
  loginUser: AppUsersDto;
  isPMBuddyBot: boolean = false;

  constructor(
    public commonService: CommonService,
    private voiceAssistantService: VoiceAssistantService,
    private loggedInUserService: LoggedInUserService,
    private actRoute: ActivatedRoute,
  ) {
    this.isPMBuddyBot = this.actRoute.snapshot.queryParams['isPMBuddyBot'];
  }

  readonly AGENT = 'AGENT';
  readonly TRANSCRIPT = 'TRANSCRIPT';
  readonly MEDIA = 'MEDIA';

  currentMainSection: string = this.AGENT;
  isMuted: boolean = false;
  isUserVideoOn: boolean = false;
  hideTranscription: boolean = false;
  isDocumentProcessing: boolean = false;
  stoppedTranscriptionStateData: any[] = [];
  askedForCamera: boolean = false;

  ngOnInit() {
    // const storedLayout = localStorage.getItem(
    //   'interviewAgentLayoutMainSection',
    // );
    this.voiceAssistantService.isDefaultView$.subscribe((isDefaultView) => {
      this.isDefaultView = isDefaultView;
    });

    this.loginUser = this.loggedInUserService.getLoggedInUser(
      LoggedInUserKeys.LOGGED_IN_USER,
    );

    // this.getCallHistoryByEmail(this.loginUser?.email);

    // if (storedLayout) {
    //   this.currentMainSection = storedLayout;
    // } else {
    //   this.currentMainSection = this.AGENT;
    //   localStorage.setItem('interviewAgentLayoutMainSection', this.AGENT);
    // }
    // this.currentMainSection = this.AGENT;
    this.isUserVideoOn = true;
  }

  ngOnDestroy() {
    localStorage.setItem('interviewAgentLayoutMainSection', this.AGENT);
  }

  // Getters (computed equivalents)
  get isAgentInMain(): boolean {
    return this.currentMainSection === this.AGENT;
  }
  get isTranscriptMain(): boolean {
    return this.currentMainSection === this.TRANSCRIPT;
  }
  get isMediaMain(): boolean {
    return this.currentMainSection === this.MEDIA;
  }
  get displayedTranscript(): any[] {
    return this.hideTranscription
      ? this.stoppedTranscriptionStateData
      : this.transcripts;
  }

  // Handlers
  handleLayout(fromLayout: 'SHORT' | 'MEDIUM') {
    if (fromLayout === 'SHORT') {
      this.currentMainSection = this.isAgentInMain
        ? this.MEDIA
        : this.isTranscriptMain
          ? this.MEDIA
          : this.AGENT;
    }
    if (fromLayout === 'MEDIUM') {
      this.currentMainSection = this.isAgentInMain
        ? this.TRANSCRIPT
        : this.isMediaMain
          ? this.TRANSCRIPT
          : this.AGENT;
    }
    localStorage.setItem(
      'interviewAgentLayoutMainSection',
      this.currentMainSection,
    );
  }

  handleSendMessage(message: string) {
    console.log(message, 'message');

    this.messageSend.emit(message);
  }

  handleMicBtn() {
    this.isMuted = !this.isMuted;
    this.micMute.emit(this.isMuted);
  }

  handleUserVideo() {
    this.isUserVideoOn = !this.isUserVideoOn;
  }

  handleTranscription() {
    this.hideTranscription = !this.hideTranscription;
    if (this.hideTranscription) {
      this.currentMainSection = this.AGENT;
      // this.stoppedTranscriptionStateData = JSON.parse(JSON.stringify(this.transcripts));
    }
  }

  askUserForVideoPermission() {
    this.isUserVideoOn = false;
    if (!this.askedForCamera) {
      this.askedForCamera = true;
      alert('Allow camera access from browser manually');
      setTimeout(() => (this.askedForCamera = false), 600);
    }
  }

  handleMinimizeCurrentSection() {
    if (this.currentMainSection !== this.AGENT) {
      this.currentMainSection = this.AGENT;
    } else {
      this.currentMainSection = this.TRANSCRIPT;
    }
    localStorage.setItem(
      'interviewAgentLayoutMainSection',
      this.currentMainSection,
    );
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) return;
    this.isDocumentProcessing = true;

    const file = input.files[0];
    const formData = new FormData();
    formData.append('file', file);

    this.commonService.uploadJD(formData).subscribe({
      next: (uploadRes) => {
        if (uploadRes?.statusCode !== 200) {
          this.isDocumentProcessing = false;
          alert('Upload failed');
          return;
        }
        const fileUrl = uploadRes.data?.previewUrl;

        const payload = {
          fileUrl: fileUrl,
        };

        this.commonService.docToText(payload).subscribe({
          next: (ocrRes) => {
            if (ocrRes?.statusCode === 200) {
              const extractedText = ocrRes.message;
              this.voiceAssistantService.handleUploadedDocument(
                fileUrl,
                extractedText,
              );
            } else {
              console.warn('No text extracted');
            }
            this.isDocumentProcessing = false;
          },
          error: (err) => {
            console.error('docToText error:', err);
            this.isDocumentProcessing = false;
          },
        });
      },

      error: (err) => {
        console.error('Upload error:', err);
        this.isDocumentProcessing = false;
      },
    });
  }

  isDefaultView: boolean = true;
  isHistoryLoading: boolean = false;

  getCallHistoryByEmail(email: string) {
    this.isHistoryLoading = true;
    this.commonService.getCallHistoryByEmail(email).subscribe({
      next: (res) => {
        if (res.statusCode === HttpStatusCode.Ok) {
          console.log('Call history:', res.data);
        }
        this.isHistoryLoading = false;
      },
      error: (err) => {
        console.error('Call history error:', err);
        this.isHistoryLoading = false;
      },
    });
  }

  showCallLayout() {
    this.commonService.getVapiToken().subscribe({
      next: (response: any) => {
        const token =
          response?.data?.token ||
          response?.token ||
          (typeof response === 'string' ? response : null);

        if (token) {
          this.vapi = new Vapi(token, `${environment.baseUrl}`);
          this.voiceAssistantService.vapi = this.vapi;
          console.log('VAPI initialized with fresh token successfully');
          this.openCallLayout();
          return;
        }

        console.warn('VAPI token missing in response. Falling back to existing VAPI instance.', {
          statusCode: response?.statusCode,
          data: response?.data,
          fullResponse: response,
        });

        if (this.voiceAssistantService.vapi) {
          this.vapi = this.voiceAssistantService.vapi;
          this.openCallLayout();
          return;
        }

        console.error('Unable to initialize VAPI: token missing and no existing instance found.');
      },
      error: (error) => {
        console.error('Error fetching VAPI token:', error);

        if (this.voiceAssistantService.vapi) {
          this.vapi = this.voiceAssistantService.vapi;
          this.openCallLayout();
          return;
        }

        console.error('Unable to open call layout because VAPI is not initialized.');
      },
    });
  }

   openCallLayout() {
    this.isDefaultView = false;
    this.changeDefaultView.emit(this.isDefaultView);
  }

  onCallEnd() {
    this.isDefaultView = true;
    this.voiceAssistantService.isAssistantSpeaking$.next(false);
    this.showVoiceCallSection$.next(false);
    this.callStartingLoadingState$.next(false);
    this.voiceAssistantService.stopVapiCall();
  }
}
